import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryApplianceIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-appliance"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M11.5477 3.92303L11.43 4.58682H10.7739H10.1176L9.99989 3.92303C9.94242 3.59854 10.0932 3.27276 10.3778 3.10676C10.6225 2.96392 10.9251 2.96392 11.1698 3.10676C11.4544 3.27276 11.6052 3.59854 11.5477 3.92303ZM18.5727 9.34114L20.289 13.3674C20.4676 13.7867 20.2576 14.2744 19.8205 14.428C19.4215 14.5682 18.983 14.3538 18.8172 13.9647L17.3081 10.4249C17.2196 10.2175 17.0158 10.0828 16.7903 10.0828H15.8323C16.4267 11.5493 17.0319 13.2947 17.4993 15.2149C17.6003 15.6303 17.2871 16.0313 16.8596 16.0313H10.774H4.68837C4.26086 16.0313 3.94768 15.6303 4.04892 15.2151C4.51634 13.2951 5.12125 11.55 5.71566 10.0836C6.19122 8.91027 6.65992 7.91556 7.04583 7.1529C7.59132 6.07497 7.97165 5.46008 7.97165 5.46008L10.7742 5.49976L13.5768 5.46008C13.5768 5.46008 14.281 6.59871 15.1483 8.49506H17.2921C17.85 8.49506 18.3539 8.82813 18.5727 9.34114Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M11.5154 4.58704C12.2564 4.58704 12.9783 4.89266 13.5758 5.45972L10.7737 5.49939L7.97168 5.45972C8.56919 4.89266 9.29089 4.58704 10.0321 4.58704H10.1175H10.7737H11.43H11.5154ZM5.8066 6.46197C5.6228 6.35924 5.4079 6.32685 5.20201 6.37082L3.64644 6.7026C3.38908 6.7575 3.27991 7.06461 3.44527 7.26964L5.71502 10.0841C6.19051 8.91052 6.65913 7.91604 7.04496 7.1534L5.8066 6.46197ZM4.50694 16.5619C4.19655 16.5619 3.98333 16.8742 4.09681 17.1633L5.18092 19.9288C5.40529 20.501 5.84524 20.8789 6.34011 20.9248L10.7739 21.0003L15.2078 20.9248C15.7026 20.8791 16.1426 20.501 16.3667 19.9288L17.4511 17.1633C17.5643 16.8744 17.3513 16.5619 17.0409 16.5619H10.7739H4.50694Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryApplianceIcon.displayName = 'CategoryApplianceIcon';
